/**
 * @generated SignedSource<<095e2c95649ac2ab43f5b6ef46d08736>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AvailabilityStatus = "ACTIVE" | "AVAILABLE" | "CONGESTED" | "DUCTED_TO_PREMISE" | "ERROR" | "FIBRE_IN_A_DAY" | "FUTURE" | "INTACT" | "NOT_PLANNED" | "PLANNED" | "READY" | "UNAVAILABLE" | "UNDEFINED" | "UNDER_BUILD" | "UNKNOWN";
export type BalanceManagement = "POSTPAID" | "PREPAID";
export type BillingFrequency = "EVERY_28_DAYS" | "MONTHLY" | "ONE_OFF" | "ONE_OFF_TOTAL" | "ORIGINAL_RRP" | "UP_FRONT";
export type CartItemAction = "add" | "delete" | "keep" | "modify";
export type ContractTermUnit = "Day" | "Hour" | "Month" | "Week" | "Year";
export type FrequencyType = "NetRecurring" | "OneOff" | "OneOffTotal" | "OriginalRRP" | "Recurring" | "Upfront";
export type ProcessContext = "ADD_VAS" | "BUY_ONE_NUMBER" | "CHANGE_OFFER" | "MANAGE_VAS" | "MOBILE_MIGRATE" | "MODIFY_OFFER" | "NEW_OFFER" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type shopCartFragment$data = {
  readonly id: string;
  readonly cartId: string;
  readonly accountNumber: string | null;
  readonly isAccountNumberRequired: boolean;
  readonly segment: string | null;
  readonly shippableItems: ReadonlyArray<{
    readonly offerId: string;
    readonly categories: ReadonlyArray<string>;
  }> | null;
  readonly bundles: ReadonlyArray<{
    readonly lineNumber: string | null;
    readonly isLineNumberRequired: boolean | null;
    readonly bundleId: string;
    readonly bundleType: string | null;
    readonly bundleSubType: string | null;
    readonly processContext: ProcessContext;
    readonly categoryId: string | null;
    readonly promotion: boolean | null;
    readonly offerIds: ReadonlyArray<string>;
    readonly availability: {
      readonly available: boolean;
      readonly offerCategory: string;
      readonly status: AvailabilityStatus;
    } | null;
    readonly items: ReadonlyArray<{
      readonly action: CartItemAction | null;
      readonly itemId: string;
      readonly productOfferingId: string;
      readonly title: string;
      readonly creditItemDescriptions: ReadonlyArray<string> | null;
      readonly description: string | null;
      readonly priceItemName: string | null;
      readonly priceItemDescriptions: ReadonlyArray<string> | null;
      readonly quantity: number;
      readonly removable: boolean | null;
      readonly editable: boolean | null;
      readonly dealText: string;
      readonly imageUrl: string | null;
      readonly totalPrice: number | null;
      readonly balanceManagement: BalanceManagement | null;
      readonly contractTerm: {
        readonly name: string | null;
        readonly value: number;
        readonly unit: ContractTermUnit;
        readonly ifpOfferId: string | null;
      } | null;
      readonly preOrderable: boolean | null;
      readonly prices: ReadonlyArray<{
        readonly billingFrequency: BillingFrequency | null;
        readonly frequencyType: FrequencyType | null;
        readonly basePrice: {
          readonly value: number;
          readonly taxExclusiveValue: number;
        } | null;
        readonly effectivePrice: {
          readonly value: number;
          readonly taxExclusiveValue: number;
        } | null;
        readonly discount: {
          readonly discountId: string | null;
          readonly type: string | null;
          readonly value: number;
          readonly discountType: string;
          readonly taxExclusiveValue: number;
          readonly discountText: string;
          readonly discountAppliedValue: number;
        } | null;
      }> | null;
      readonly offerId: string;
      readonly categories: ReadonlyArray<string>;
      readonly dataLayerCategory: string | null;
      readonly isIncluded: boolean | null;
      readonly shouldHide: boolean | null;
      readonly promotion: boolean | null;
    }> | null;
  }> | null;
  readonly auth: {
    readonly isAuthenticated: boolean;
    readonly isGuest: boolean;
  };
  readonly summaries: ReadonlyArray<{
    readonly billingFrequency: BillingFrequency | null;
    readonly frequencyType: FrequencyType;
    readonly subtotal: number;
    readonly total: number;
    readonly taxExclusiveSubtotal: number;
    readonly discount: number | null;
    readonly taxExclusiveDiscount: number | null;
    readonly taxExclusiveTotal: number;
    readonly gst: number;
  }> | null;
  readonly mpdDiscountPercentage: number | null;
  readonly productOfferImages: ReadonlyArray<{
    readonly offerId: string;
    readonly url: string | null;
    readonly type: string | null;
  }> | null;
  readonly " $fragmentType": "shopCartFragment";
};
export type shopCartFragment$key = {
  readonly " $data"?: shopCartFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"shopCartFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categories",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promotion",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billingFrequency",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frequencyType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taxExclusiveValue",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "channel"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "shopCartFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cartId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAccountNumberRequired",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "segment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "shippableItems",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Bundle",
      "kind": "LinkedField",
      "name": "bundles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lineNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLineNumberRequired",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bundleId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bundleType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bundleSubType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "processContext",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryId",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offerIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Availability",
          "kind": "LinkedField",
          "name": "availability",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "available",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "offerCategory",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "action",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productOfferingId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "creditItemDescriptions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceItemName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "priceItemDescriptions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "removable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "editable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dealText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balanceManagement",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ContractTerm",
              "kind": "LinkedField",
              "name": "contractTerm",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "unit",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ifpOfferId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "preOrderable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CartPriceFull",
              "kind": "LinkedField",
              "name": "prices",
              "plural": true,
              "selections": [
                (v4/*: any*/),
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CartPrice",
                  "kind": "LinkedField",
                  "name": "basePrice",
                  "plural": false,
                  "selections": (v7/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CartPrice",
                  "kind": "LinkedField",
                  "name": "effectivePrice",
                  "plural": false,
                  "selections": (v7/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CartDiscount",
                  "kind": "LinkedField",
                  "name": "discount",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "discountId",
                      "storageKey": null
                    },
                    (v8/*: any*/),
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "discountType",
                      "storageKey": null
                    },
                    (v6/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "discountText",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "discountAppliedValue",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dataLayerCategory",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isIncluded",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shouldHide",
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Auth",
      "kind": "LinkedField",
      "name": "auth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAuthenticated",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Summary",
      "kind": "LinkedField",
      "name": "summaries",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subtotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taxExclusiveSubtotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "discount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taxExclusiveDiscount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taxExclusiveTotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "gst",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mpdDiscountPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "channel",
          "variableName": "channel"
        }
      ],
      "concreteType": "ProductOfferImage",
      "kind": "LinkedField",
      "name": "productOfferImages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Cart",
  "abstractKey": null
};
})();

(node as any).hash = "ce694a6b250670a44a77d756d5c540e1";

export default node;
